import { getApps, initializeApp } from "firebase/app"
import {
  deleteToken,
  getMessaging,
  getToken,
  isSupported,
  onMessage,
} from "firebase/messaging"
import config from "../config"

let messagingPromise
const FIREBASE_APP_NAME = "pwa-push"

const getFirebaseApp = () => {
  const existingApp = getApps().find((app) => app.name === FIREBASE_APP_NAME)
  return existingApp || initializeApp(config.firebase.config, FIREBASE_APP_NAME)
}

const getServiceWorkerRegistration = async () => {
  const registration = await navigator.serviceWorker.getRegistration()
  if (registration) return registration

  return Promise.race([
    navigator.serviceWorker.ready,
    new Promise((resolve) => setTimeout(() => resolve(null), 3000)),
  ])
}

const getFirebaseMessaging = async () => {
  if (!messagingPromise) {
    messagingPromise = isSupported().then((supported) => {
      if (!supported || !config.firebase?.config) return null
      return getMessaging(getFirebaseApp())
    })
  }
  return messagingPromise
}

export const isPushMessagingSupported = async () => {
  if (!config.firebase?.config || !config.firebase?.vapidKey) return false
  if (!("Notification" in window) || !("serviceWorker" in navigator)) {
    return false
  }
  return isSupported()
}

export const getCurrentFcmToken = async () => {
  const messaging = await getFirebaseMessaging()
  if (!messaging || !config.firebase?.vapidKey) return ""

  const serviceWorkerRegistration = await getServiceWorkerRegistration()
  if (!serviceWorkerRegistration) return ""

  return getToken(messaging, {
    vapidKey: config.firebase.vapidKey,
    serviceWorkerRegistration,
  })
}

export const deleteCurrentFcmToken = async () => {
  const messaging = await getFirebaseMessaging()
  if (!messaging) return false
  return deleteToken(messaging)
}

export const onForegroundPushMessage = async (handler) => {
  const messaging = await getFirebaseMessaging()
  if (!messaging) return () => {}
  return onMessage(messaging, handler)
}
